module.exports = __webpack_public_path__ + "img/92125.071c047b.svg";